import instructorRoutes from "./Instructor";
/**
 * Combine and export the routes defined in the admin module for better organization and easier usage.
 * @constant {Object} adminRouteMap
 */
const instructorRouteMap = {
  ...instructorRoutes,
};
export default instructorRouteMap;
